/*jshint esversion: 8 */
class PredictiveSearch {
    constructor() {
        this.searchForm = document.querySelector(".widget_supapress_search .search-form");
        this.searchInput = this.searchForm ? this.searchForm.querySelector(".search-field") : '';
        this.predictiveContainer = document.querySelector(
            ".js-predictive-container"
        );
        this.searchContainer = document.querySelector('.js-header-site-search');
        this.allPredictiveLists = this.predictiveContainer ? this.predictiveContainer.querySelectorAll(
            ".predictive-list__inner"
        ) : '';
        this.activeClass = "search-open";
        this.productsContainer = this.predictiveContainer ? this.predictiveContainer.querySelector(
            "[data-type='Products']"
        ) : '';
        this.contributorsContainer = this.predictiveContainer ? this.predictiveContainer.querySelector(
            "[data-type='Contributors']"
        ) : '';
    }

    htmlDecode(input) {
        const e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    showHideSearchForm() {
        const searchToggleBtn = document.querySelectorAll(".search-trigger");
        const closeForm = document.getElementById("search-close");
        const {activeClass} = this;

        // if there is no mobile btn or mainNav do not run the code
        if( !searchToggleBtn || !this.searchForm ) {
            return;
        }

        searchToggleBtn.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                this.searchForm.classList.toggle(activeClass);
                this.searchContainer.classList.toggle(activeClass);
                if( this.searchForm.classList.contains(activeClass) ) {
                    this.searchInput.focus();
                    this.allPredictiveLists.forEach((list) => {
                        if( list.innerHTML.length >= 1 ) {
                            this.predictiveContainer.style.display = "block";
                        }
                    });
                } else {
                    this.searchInput.blur();
                }
            });
        });

        closeForm.addEventListener("click", (e) => {
            e.preventDefault();
            this.hidePredictiveSearch();
        });
    }

    hidePredictiveSearch() {
        if( !this.searchForm ) {
            return;
        }
        this.searchForm.classList.remove(this.activeClass);
        this.searchContainer.classList.remove(this.activeClass);
        this.predictiveContainer.style.display = "none";
    }

    handleSupafolioResults(results, container) {
        if( !results ) return;
        const {predictive_book_url_pattern} = universityPressThemeSettings;
        const {site_url} = universityPressThemeSettings;
        container.innerHTML = '';
        let value;
        for( let i = 0; i < universityPressThemeSettings.predictive_results_amount; i += 1 ) {
            value = results[i];
            if( !value || !value.seo || !value.name ) {
                return;
            }
            value.seo = value.seo.replace(/(<([^>]+)>)/gi, "");
            value.name = value.name.replace(/(<([^>]+)>)/gi, "");

            //default to contributor url
            let url = `${universityPressThemeSettings.default_search_page_slug}?contributor=${value.seo}`;
            if( container.getAttribute('data-type') === 'Products' ) {
                url = site_url + predictive_book_url_pattern;
                url = url.replace("%isbn13%", value.id);
                url = url.replace("%title%", value.seo);
            }

            const newLi = document.createElement("li");
            newLi.innerHTML = `<a href="${url}" class="predictive-list__item">${this.htmlDecode(value.name)}</a>`;
            container.appendChild(newLi);
        }
    }

    errorHandler(resultsContainer) {
        resultsContainer.innerHTML = `<li><p>${universityPressThemeSettings.predictive_books_no_results}</p></li>`;
    }

    insertLoader(container) {
        container.innerHTML = "";
        const loader = document.createElement("div");
        loader.className = "loader";
        container.appendChild(loader);
    }

    hideLoader(container) {
        const loaderShown = container.querySelector(".loader");
        if(!loaderShown) return;
        loaderShown.parentNode.removeChild(loaderShown);
    }

    wordpressPredictiveSearch(input, type, wpAction) {
        if( input.length < 3 ) {
            this.clearPredictive();
            return;
        }
        // add loader
        const resultsContainer = this.predictiveContainer.querySelector("[data-type='" + type + "']");
        if( !resultsContainer ) {
            return;
        }

        this.insertLoader(resultsContainer);

        // fetch api call for products and contributors
        const supafolioData = this.getData(input, wpAction);

        return supafolioData.then((item) => {
            this.hideLoader(resultsContainer);

            if( item.status === "error" ) {
                this.errorHandler(resultsContainer);
                return;
            }

            if( item.status === "success" ) {
                let value;
                for( let i = 0; i < universityPressThemeSettings.predictive_results_amount; i += 1 ) {
                    value = item.data.predictive[i];
                    if( !value || !value.link || !value.label ) {
                        return;
                    }
                    const newLi = document.createElement("li");
                    newLi.innerHTML = `<a class="predictive-list__item" href="${value.link}">${this.htmlDecode(value.label)}</a>`;
                    resultsContainer.appendChild(newLi);
                }
            }
        });
    }

    async supafolioPredictiveSearch(input) {
        this.insertLoader(this.productsContainer);
        this.insertLoader(this.contributorsContainer);

        // fetch api call for products and contributors
        const supafolioData = this.getData(input, 'upt_supafolio_predictive_search');

        return supafolioData.then((item) => {
            this.hideLoader(this.productsContainer);
            this.hideLoader(this.contributorsContainer);

            if( item.status === "error" ) {
                this.errorHandler(this.productsContainer);
                this.errorHandler(this.contributorsContainer);
            }

            if( item.status === "success" ) {
                if( !item.data.predictive ) {
                    return;
                }

                const results = item.data.predictive;
                const products = results.filter(
                    (data) => data.type === "Products"
                );
                const contributors = results.filter(
                    (data) => data.type === "Contributors"
                );

                if( products.length > 0 ) {
                    this.productsContainer.style.display = "block";
                    this.handleSupafolioResults(
                        products,
                        this.productsContainer
                    );
                }

                if( contributors.length > 0 ) {
                    this.contributorsContainer.style.display = "block";
                    this.handleSupafolioResults(
                        contributors,
                        this.contributorsContainer
                    );
                }
            }
        });
    }

    async getData(input, wpAction) {
        const data = new FormData();

        data.append('action', wpAction);
        data.append('value', input);

        try {
            const response = await fetch(universityPressThemeSettings.wordpressAjaxUrl, {
                method: "POST",
                credentials: 'same-origin',
                body: data
            });
            return await response.json();
        } catch( e ) {
            console.error(e);
        }
    }

    removeResultsLink() {
        const elem = document.querySelector(".result-link");
        if( !elem ) return;
        elem.parentNode.removeChild(elem);
    }

    // return predictive list data
    async getPredictiveLists(value) {
        if( value.length < 3 ) {
            this.clearPredictive();
            return;
        }

        // if search opened and input length > 3, show predictive container
        if( this.searchForm.classList.contains("search-open") ) {
            this.predictiveContainer.style.display = "block";
        }

        // fetch to get books and contributors
        Promise.resolve(this.supafolioPredictiveSearch(value)).then(() => {
            this.removeResultsLink();
            const newDiv = document.createElement("div");
            let searchUrl = `${universityPressThemeSettings.default_search_page_slug}?keyword=${value}`;
            newDiv.className = "site-container result-link";
            newDiv.innerHTML = `<a href="${searchUrl}" class="site-cta-button">${universityPressThemeSettings.predictive_cta_copy}</a>`;
            this.predictiveContainer.appendChild(newDiv);
        });
    }

    inputSearches() {
        if( !this.searchInput ) {
            return;
        }
        // Init a timeout variable to be used below
        let timeout = null;
        this.searchInput.addEventListener("keyup", (e) => {
            e.target.value = e.target.value.trimStart() || '';
            const { value } = e.target;
            clearTimeout(timeout);
            // Make a new timeout set to go off in 250ms
            timeout = setTimeout(() => {
                this.getPredictiveLists(value);
                this.wordpressPredictiveSearch(value, 'Content', 'upt_predictive_search');
                if( universityPressThemeSettings.predictive_enable_journals ) {
                    // ajax to get journals
                    this.wordpressPredictiveSearch(value, 'Journals', 'upt_journals_predictive_search');
                }
            }, 250);
        });
    }

    clearPredictive() {
        this.predictiveContainer.style.display = "none";
        this.removeResultsLink();
        this.allPredictiveLists.forEach((e) => {
            e.innerHTML = "";
        });
    }

    // close search if escape, or click outside header
    eventListeners() {
        document.addEventListener("keydown", (e) => {
            if( e.key === "Escape" ) {
                this.hidePredictiveSearch();
            }
        });

        document.addEventListener(
            "click",
            (e) => {
                if(
                    e.target.matches("#search-close") ||
                    !e.target.closest(".js-site-header")
                ) {
                    this.hidePredictiveSearch();
                }
            },
            false
        );
    }

    run() {
        this.showHideSearchForm();
        this.inputSearches();
        this.eventListeners();
    }
}

// predictive search
const predictiveSearch = new PredictiveSearch();
predictiveSearch.run();
